import axios from 'axios';

/**
 * Ejecuta una ruta LLM como job async (D-12): POST {startUrl} → {job_id},
 * luego polling GET {statusBase}/{jobId} hasta done/failed. Evita el corte
 * del edge (Cloudflare 100 s) en respuestas LLM largas.
 *
 * Devuelve { data: result } para imitar la forma de una respuesta axios y
 * no tocar el resto de la lógica de cada caller.
 *
 * Si el backend no devuelve job_id (endpoint antiguo), usa la respuesta directa.
 */
export async function runAiJob({
  startUrl,
  statusBase,
  body = {},
  config = {},
  intervalMs = 2500,
  maxMs = 240000,
  onStage,
}) {
  const startResp = await axios.post(startUrl, body, config);
  const jobId = startResp?.data?.job_id;
  if (!jobId) {
    return startResp; // compat con endpoints síncronos antiguos
  }

  const deadline = Date.now() + maxMs;
  let delay = 1500;
  let netErrors = 0;

  while (Date.now() < deadline) {
    await new Promise((r) => setTimeout(r, delay));
    delay = intervalMs;

    let poll;
    try {
      poll = await axios.get(`${statusBase}/${jobId}`, config);
      netErrors = 0;
    } catch (e) {
      if (e?.response?.status === 404) throw e;
      if (++netErrors > 5) throw e;
      continue;
    }

    const d = poll?.data || {};
    if (onStage) onStage(d.status);

    if (d.status === 'done') {
      return { data: d.result, status: 200, _job: d };
    }
    if (d.status === 'failed') {
      const err = new Error(d.error || 'El procesamiento con IA falló');
      err.response = { status: d.status_code || 500, data: { detail: d.error } };
      throw err;
    }
  }

  const to = new Error('El procesamiento con IA tardó demasiado. Inténtalo de nuevo.');
  to.response = { status: 504, data: { detail: 'timeout' } };
  throw to;
}
